import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit"]
  static values = { siteName: String }

  check(event) {
    const input = event.target.value.trim()
    this.submitTarget.disabled = input !== this.siteNameValue
  }
}
